import { ReactComponent as ChartBar } from './ChartBar.svg';
import { ReactComponent as ChartPie } from './ChartPie.svg';
import { ReactComponent as ClipboardText } from './ClipboardText.svg';
import { ReactComponent as CreditCard } from './CreditCard.svg';
import { ReactComponent as GearSix } from './GearSix.svg';
import { ReactComponent as SignOut } from './SignOut.svg';
import { ReactComponent as Logo } from './logo.svg';

export function LogoIcon() {
  return <Logo />;
}

export function ChartBarIcon() {
  return <ChartBar />;
}

export function ChartPieIcon() {
  return <ChartPie />;
}

export function ClipboardTextIcon() {
  return <ClipboardText />;
}

export function CreditCardIcon() {
  return <CreditCard />;
}

export function GearSixIcon() {
  return <GearSix />;
}

export function SignOutIcon() {
  return <SignOut />;
}
